import { useContext } from 'react';

import { TableHoverContext } from './TableHoverContext';

export const useTableHover = () => {
  return useContext(TableHoverContext);
};
